import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Aplikasisekolah: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi Sekolah" />
    <h1><strong><a href="/aplikasisekolah/">Aplikasi Sekolah</a></strong></h1>
<img className="img-fluid" alt="aplikasi sekolah" src="/img/mesinkasironlineapp8.jpg"/>
    <p>
Special untuk kebutuhan dunia pendidikan khusus nya sekolah agar lebih mempermudah dalam proses belajar mengajar hingga berbagai kebutuhan dalam penggunaan nya , mulai dari e-learning ujian online, absensi online, pembayaran keuangan sekolah , ERP lengkap hingga untuk content management system khusus dipergunakan pada sekolah, ini adalah era update digital technology sekolah khusus nya bersama <a href="/aplikasisekolah/">aplikasi sekolah</a> kami
    </p>
    <p>Mulai pilih <a href="/aplikasisekolah/">applikasi sekolah</a> sekarang.</p>
<div className="row">
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-4Ag9pJJ-d5A/X-NO8DO3sYI/AAAAAAAAMFs/hPWIqgqerIcGoyYWPfTpyE07iy8zPRq2ACLcBGAsYHQ/s300/aplikasi%2Belearning%2Bonline%2Bsimple%2Bbelajar%2Bmengajar%2Bsekolah%2B%25287%2529.png"/>
<p>
    E-Learn Simple<br/>
 Untuk kebutuhan aplikasi sekolah e-learning online dengan simple system.</p>
<Link to="/elearnsimple/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-WDdg3UXKv_g/X-Nf1VmY75I/AAAAAAAAMHQ/AdPWUiS8SRAnzd7gv0cDdgB08gDkolOWgCLcBGAsYHQ/s300/aplikasi%2Bbelajar%2Bsekolah%2Bonline%2B%25282%2529.png"/>
<p>
    E-Learn Media<br/>
Solusi aplikasi e-learning dengan upload dan download media proses belajar mengajar.
</p>
<Link to="/elearnmedia/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-7t_1tTVz5f4/X-Ap3esy11I/AAAAAAAAL4g/AbBFWPEQJpcjZYgbPlbNW1xTusvdWczZgCLcBGAsYHQ/s1200/aplikasi-belajar-online-sekolah-e-learning.jpg"/>
<p>E-Learn Premium
    <br/>
E-learning online dengan berbagai kelengkapan untuk mendukung proses belajar mengajar.
</p>
<Link to="/elearnpremium/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-Liqtghhb_jQ/X-NtLdVBGtI/AAAAAAAAMJc/I02dos1fP7cK0CpDYzMtBdMmkG_TX783gCLcBGAsYHQ/s1830/aplikasi%2Babsensi%2Bsiswa%2Bsekolah%2Bonline%2B.jpg"/>
<p>Absensi APps
    <br/>
Untuk kebutuhan absensi online murid siswa sekolah
</p>
<Link to="/absensikelas/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-NFgN5p_eDWE/X-Nypx6cGlI/AAAAAAAAMKc/uC1GCkM0NoUf9f4lXWoKmuKuwLUU7o0GQCLcBGAsYHQ/s1200/aplikasi%2Brapot%2Bsiswa%2Bonline.jpg"/>
<p>E-Rapot
    <br/>
Aplikasi rapot online sekolah dan penilaian.
</p>
<Link to="/rapotonline/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-zFOEf0owiRM/X-Ap5JaizXI/AAAAAAAAL4w/Ha9KB9jC3dMZp8ZCpZRDgIivtFTtTh4kwCLcBGAsYHQ/s860/aplikasi-pembayaran-sekolah-online-brochure.jpg"/>
<p>Payment Apps
    <br/>
APlikasi pembayaran keuangan sekolah lengkap laporan.
</p>
<Link to="/pembayaransekolah/" className="button">More info</Link>
    </div>
    
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-HlK8vnGTTKM/X-N-FTJN88I/AAAAAAAAMLs/1VYyIwWGYkY5LJQJx6VSAfccSI6ly-ifwCLcBGAsYHQ/s300/aplikasi%2Bsekolah%2Bonline%2Be-learn%2Bwebsite%2Bsekolah%2B%25285%2529.png"/>
<p>ERP School
    <br/>
Super lengkap untuk kebutuhan sekolah dengan aplikasi sekolah online ini.
</p>
<Link to="/erpsekolah/" className="button">More info</Link>
    </div>
    
    <div className="p-3 p-md-5 col-12 col-md-4">
    <img className="img-fluid rounded" alt="aplikasi sekolah" 
src="https://1.bp.blogspot.com/-p68RWMOjPl0/X-ONm7LX_qI/AAAAAAAAMM8/UecpCVeRpQYuqy7_yy2Na0RmKY1Qlp_oACLcBGAsYHQ/s1828/aplikasi%2Bpembuatan%2Bwebsite%2Bsekolah%2Bgratis%2Bdari%2Baxcora%2Btechnology%2Baxcora%2Bschool%2Bweb%2Bapp2.jpg"/>
<p>CMS Sekolah
    <br/>
Aplikasi pembuatan website sekolah include domain sch.id siap digunakan.
</p>
<Link to="/websitesekolah//" className="button">More info</Link>
    </div>

      </div>
    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Aplikasisekolah

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
